export default __webpack_public_path__ + "static/article-real-stories-saving-spending-lending-amin-3fa7e1609cadb50655b626cb4dc59288.jpg";